import { type UseQueryOptions, useQueries, useQuery } from 'react-query';

import { http } from '../base/http';

export interface SvgFileQueriesResult {
    url: string;
    file: string;
}

export const useSvgFileQueries = (urls: string[], options?: UseQueryOptions<SvgFileQueriesResult, Error>) => {
    return useQueries(
        urls.map((url) => ({
            queryKey: ['svg_files', url],
            queryFn: () =>
                http
                    .getFile(url, 'image/svg+xml')
                    .then((res) => res.text())
                    .then((file) => {
                        return { url, file };
                    }),
            staleTime: Number.POSITIVE_INFINITY,
            cacheTime: Number.POSITIVE_INFINITY,
            ...options,
        })),
    );
};
